import React, { useEffect, useState } from "react";
import $ from "jquery";
import { Link } from "react-router-dom";
import Swal from "sweetalert2";
import {
  getLocalKey,
  getUser,
  logOutUser,
  setLocalKey,
} from "../../../utils/commonfunction";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { ROLE, THEME_COLORS } from "../../../utils/Constants";
import { Tooltip, Whisper } from "rsuite";
import profilePic from '../../../assets/admin/img/profile.jpg'

const Header = ({ updateHeader }) => {
  const [profile, setProfile] = useState("");
  const showprofile = useSelector((state) => state.profile.file);
  const [username, setUserName] = useState("");
  let { i18n, t } = useTranslation();
  const selected_language = localStorage.getItem("system_language") ? localStorage.getItem("system_language") : "en"
  let languageCode = {
    en: "EN",
    // ja: "日本語"
    ja: 'JA'
  }
  const [email , setEmail]= useState("")
  // console.log(languageCode[selected_language])

  const adminData = useSelector((state) => state.profile.profileData);

  useEffect(() => {
    const getuser = getUser(ROLE.SUPER_ADMIN);
    const trimmedName = (getuser?.name)?.slice(0, 25);
    setEmail(getuser?.email||"")
    setUserName(trimmedName);
    // setUserName(getuser.name);
    setProfile(
      showprofile && showprofile.file
        ? URL.createObjectURL(showprofile.file)
        : getuser.profile_image
    );
  }, [showprofile , adminData ]);





  useEffect(() => {
    $(document).ready(function () {
      $(".showpop").click(function () {
        $(".main-profile-menu").addClass("show");
      });
      $(".fixed_bg").click(function () {
        $(".main-profile-menu").removeClass("show");
      });
    });
  }, []);

  const toggleSidebar = (e) => {
    e.preventDefault();
    if ($("body").hasClass("main-sidebar-hide")) {
      $("body").removeClass("main-sidebar-hide"); console.log(languageCode.seleccted_language)
    } else {
      $("body").addClass("main-sidebar-hide");
    }
  };

  const logout = () => {
    Swal.fire({
      customClass: "swal-wide",
      title: t("msg_are_you_sure"),
      text: t("text_you_want_to_logout"),
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: THEME_COLORS.ADMIN_PRIMARY,
      cancelButtonColor: "#000",
      confirmButtonText: t("btn_yes"),
      cancelButtonText: t("btn_cancel")
    }).then((result) => {
      if (result.isConfirmed) {
        logOutUser(ROLE.SUPER_ADMIN);
      }
    });
  };
  function getRoleName() {
    let roleName = null;
    const userData = getLocalKey(ROLE.SUPER_ADMIN) ? JSON.parse(getLocalKey(ROLE.SUPER_ADMIN)) : {};
    let role = userData.role[0];
    switch (role) {
      case ROLE.SUPER_ADMIN:
        roleName = t("role_super_admin");
        break;
      case ROLE.RESTAURANT:
        roleName = t("sidebar_link_restaurant");
        break;
      case ROLE.STAFF:
        roleName = "role_staff";
        break;
      default:
        roleName = "role_unknown";
    }
    return roleName;
  }
  useEffect(() => {
    const onFullScreenChange = () => {
      const isFullScreen =
        document.fullscreenElement ||
        document.mozFullScreenElement ||
        document.webkitFullscreenElement ||
        document.msFullscreenElement;
      if (!isFullScreen) {
        $('html').removeClass('fullscreen');
        $('.fullscreen-button.fullscreen').show();
        $('.fullscreen-button.exit-fullscreen').hide();
      } else {
        $('.fullscreen-button.fullscreen').hide();
        $('.fullscreen-button.exit-fullscreen').show();
      }
    };
  
    document.addEventListener('fullscreenchange', onFullScreenChange);
    document.addEventListener('webkitfullscreenchange', onFullScreenChange);
    document.addEventListener('mozfullscreenchange', onFullScreenChange);
    document.addEventListener('MSFullscreenChange', onFullScreenChange);
  
    return () => {
      document.removeEventListener('fullscreenchange', onFullScreenChange);
      document.removeEventListener('webkitfullscreenchange', onFullScreenChange);
      document.removeEventListener('mozfullscreenchange', onFullScreenChange);
      document.removeEventListener('MSFullscreenChange', onFullScreenChange);
    };
  }, []);

  function handleFullScreen() {
    const isFullScreen =
      document.fullscreenElement ||
      document.webkitFullscreenElement ||
      document.mozFullScreenElement ||
      document.msFullscreenElement;

    if (!isFullScreen) {
      document.documentElement.requestFullscreen?.();
      document.documentElement.webkitRequestFullscreen?.();
      document.documentElement.mozRequestFullScreen?.();
      document.documentElement.msRequestFullscreen?.();
    } else {
      document.exitFullscreen?.();
      document.webkitExitFullscreen?.();
      document.mozCancelFullScreen?.();
      document.msExitFullscreen?.();
    }
  }
  

  return (
    <>
      {/* <!-- Main Header--> */}
      <div className="main-header side-header">
        <div className="container-fluid">
          <div className="main-header-left">
            <Whisper placement="right" controlId="control-id-hover" trigger="hover" speaker={ <Tooltip style={{fontWeight:'bold'}}>Resize sidebar</Tooltip> }>
            <a
              className="main-header-menu-icon e_none"
              href="/"
              id="mainSidebarToggle"
              onClick={toggleSidebar}
            >
              <span></span>
            </a>
                </Whisper>
          </div>
          <div className="main-header-center">
            <div className="responsive-logo">
              {/* <a href="index.html"><img src={logo} className="mobile-logo" alt="logo" /></a> */}
              {/* <a href="index.html"><img src="../assets/img/brand/Mask Group 1.png" className="mobile-logo" alt="logo" /></a>
							<a href="index.html"><img src="../assets/img/brand/Mask Group 1.png" className="mobile-logo-dark" alt="logo" /></a> */}
            </div>
          </div>
          
          <div className="main-header-right">
              <div className="dropdown d-md-flex">
                <button className="nav-link icon full-screen-link" onClick={handleFullScreen}>
                  <Whisper placement="left" controlId="control-id-hover" trigger="hover" speaker={ <Tooltip style={{fontWeight:'bold'}}>Full screen view</Tooltip> }>
                    <i className="fe fe-maximize fullscreen-button fullscreen header-icons" style={{ display: 'inline' }}></i>
                  </Whisper>
                  <Whisper placement="left" controlId="control-id-hover" trigger="hover" speaker={ <Tooltip style={{fontWeight:'bold'}}>Exit full screen view</Tooltip> }>
                  <i className="fe fe-minimize fullscreen-button exit-fullscreen header-icons" style={{ display: 'none' }}></i>
                    {/* <i className="fe fe-maximize fullscreen-button fullscreen header-icons"></i> */}
                  </Whisper>
                </button>
              </div>		
                
            <div
              className={`dropdown main-profile-menu d-flex align-items-center`}
            >
              {/* <a className="d-flex" href="javascript:void(0)">
								<span className="main-img-user" onClick={() => setShowProfile(!showprofile)}><img alt="avatar" src="../assets/img/brand/Mask Group 1@2x.png"/></span>
							</a> */}
              <button className="d-flex border-0 bg-white showpop">
                {/* <span className="main-img-user">
                  <FaUserCog size={30} />
                </span> */}
                <span className="main-img-user">
                  <img alt="border avatar" src={profile} />
                  {/* <img alt="border avatar" src={profile} /> */}
                </span>
              </button>
              <div className="dropdown-menu">
                <span className="fixed_bg"></span>  
                <div
                  className="position-relative headerdropdown"
                  style={{ zIndex: "99999" }}
                >
                  <div className="header-navheading">
                    <h4 className="main-notification-title text-capitalize">
                      {username}
                    </h4>
                    <p className="main-notification-text">{email}</p>
                  </div>
                
                  <Link
                    className="dropdown-item fixed_bg"
                    to={`/admin/profile/edit/${"1"}`}
                  >
                   
                   <i className="fe fe-edit"></i> {t("btn_edit")} {t("label_profile")}
                  </Link>
                  
                       



                  <button className="dropdown-item fixed_bg"  onClick={() => {logout()}}>
                    <i className="fe fe-power"></i> {t("label_logout")}
                  </button> 
                </div>
               
              </div>
            </div>

            <button
              className="navbar-toggler navresponsive-toggler"
              type="button"
              data-toggle="collapse"
              data-target="#navbarSupportedContent-4"
              aria-controls="navbarSupportedContent-4"
              aria-expanded="false"
              aria-label="Toggle navigation"
            >
              <i className="fe fe-more-vertical header-icons navbar-toggler-icon"></i>
            </button>
            {/* <!-- Navresponsive closed --> */}
          </div>
        </div>
      </div>
      {/* <!-- End Main Header--> */}
    </>
  );
};

export default Header;
